app.controller("SelectionDetailsController", [
    "$scope", "Socket", "Selection", "Session", "Subject", "StaticData", "$stateParams", "$uibModal", "ConfirmModal", "$state", "$q", "toastr", "usSpinnerService",
    function ($scope, Socket, Selection, Session, Subject, StaticData, $stateParams, $uibModal, ConfirmModal, $state, $q, toastr, usSpinnerService) {
        $scope.query = $stateParams.query;
        $scope.perPageVersions = ['25', '50', '100', '200'];

        $scope.itemsPerPage = $stateParams.limit || '25';
        $scope.itemsPerPageSelector = $stateParams.limit || '25';
        $scope.group = $stateParams.group;
        $scope.adminState = $state.current.name === 'admin.selection-details';

        $scope.changePerPage = function () {
            $state.go(".", {limit: $scope.itemsPerPageSelector});
        };

        $scope.printGroupSheet = function () {
            window.open('selection/group/export/' + $scope.group);
        };

        $scope.exportGroupSheet = function () {
            window.open('selection/export/' + $stateParams.activationId);
        };

        StaticData.getItemsByKey("states").then(function (states) {
            $scope.states = states;
            $scope.statesMap = _.keyBy($scope.states, '_id');
        });

        usSpinnerService.spin("root");
        $q.all([
            StaticData.getItemsByKey("days"),
            StaticData.getItemsByKey("session_types"),
            StaticData.getItemsByKey("selection_states"),
            StaticData.getItemsByKey("states")
        ]).then(function (results) {
            // days
            $scope.days = results[0];
            $scope.daysMap = _.keyBy($scope.days, '_id');

            // session types
            $scope.sessionTypes = results[1];
            $scope.sessionTypesMap = _.keyBy($scope.sessionTypes, '_id');

            // selection_states
            $scope.selectionStates = results[2];
            $scope.selectionStatesMap = _.keyBy($scope.selectionStates, '_id');

            // student_states
            $scope.states = results[3];
            $scope.statesMap = _.keyBy($scope.states, '_id');

            update();
        });


        function fetchActivation() {
            return Selection.getActivation($stateParams.activationId).then(function (activation) {
                $scope.activation = activation;
            });
        }

        $scope.details = function (selection, $event) {
            selection.name = $scope.activation.subject.name;
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "DetailsController",
                templateUrl: _pb + 'student/card/details.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    subject: function () {
                        return selection
                    }
                }
            }).result
                .then(function (result) {

                });
        };

        function fetchSelections(page, cb) {
            cb = cb || function () {

            };
            return Selection.selectionsByActivation({
                activationId: $stateParams.activationId,
                query: $stateParams.query,
                page: page,
                limit: $scope.itemsPerPage,
                group: $stateParams.group
            }).then(function (data) {
                $scope.totalItems = data.total;
                $scope.selections = data.docs;
                $scope.emails = "";
                $scope.selections.forEach(function (sel) {
                    if(sel.profile.user.email) {
                        $scope.emails += sel.profile.user.email + ', ';
                    }
                });
                $scope.emails = $scope.emails.substring(0, $scope.emails.length - 2);
                cb();
            });
        }

        $scope.copy = function () {
            var copyText = document.getElementById("emails");
            copyText.select();
            copyText.setSelectionRange(0, 99999)
            document.execCommand("copy");
        }

        function fetchSessions(cb) {
            cb = cb || function () {

            };
            return Session.groupList($stateParams.activationId).then(function (data) {
                $scope.sessionGroups = [{name: "ყველა"}].concat(data);
                $scope.sessionGroupsMap = _.keyBy(data, '_id');
                _(data).each(function (group) {
                    group.type = $scope.sessionTypesMap[group.sessionType].name;
                    group.days = _(group.sessions).map('dayOfWeek').map(function (day) {
                        return day ? $scope.daysMap[day].name : '';
                    }).uniq().value().join(', ');
                    group.name = (group.title && group.title.length ? group.title : group.type) + " - " + group.days;
                });
                $scope.sessions = _.groupBy(data, 'sessionType');
                cb();
            });
        }

        function bindSessionGroups() {
            $scope.selections = $scope.selections.map(function (selection) {
                selection.subjectSessionGroups.forEach(function (group) {
                    var sessionGroup = $scope.sessionGroupsMap[group];
                    if (sessionGroup) selection[sessionGroup.sessionType] = sessionGroup;
                });
                return selection;
            });
        }

        function update() {
            usSpinnerService.spin("root");
            $q.all([
                fetchSelections($stateParams.page),
                fetchSessions(),
                fetchActivation()
            ]).then(function () {
                bindSessionGroups();
                usSpinnerService.stop("root");
                $scope.currentPage = $stateParams.page;
            }).catch(function (err) {
                console.error(err)
            })
        }

        // update();

        $scope.addStudent = function () {
            $uibModal.open({
                controller: "AddStudentSelectionController",
                templateUrl: _pb + 'admin/selection/add-student-selection.html',
                size: "md",
                scope: $scope,
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            subjectActivation: $scope.activation._id,
                            sessions: $scope.sessions,
                            subjectName: $scope.activation.subject.name,
                            update: update
                        };
                    }
                }
            }).result.then(function () {
                update();
            });
        };

        $scope.editStudent = function (selection) {
            $uibModal.open({
                controller: "EditStudentSelectionController",
                templateUrl: _pb + 'admin/selection/edit-student-selection.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            subjectSelection: selection,
                            subjectActivation: $scope.activation,
                            sessions: $scope.sessions
                        };
                    }
                }
            }).result.then(function () {
                update();
            });
        };

        $scope.remove = function (subjectSelection) {
            ConfirmModal.show({
                title: "არჩევანის წაშლა",
                message: "გსურთ ამ არჩევანის წაშლა?"
            }).result.then(function () {
                Selection.removeSelection(subjectSelection).then(update);
            });
        };

        $scope.choose = function (selection) {
            var lecture = selection.subjectSessionGroups[0];
            var seminar = selection.subjectSessionGroups[1];
            Selection.prove({
                selection: selection._id,
                seminar: seminar,
                lecture: lecture
            }).then(function () {
                fetchSelections($stateParams.page);
            })
        };

        $scope.applyFilter = function () {
            $state.go(".", {
                query: $scope.query,
                group: $scope.group
            });
        };

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        $scope.selectAll = function () {
            angular.forEach($scope.selections, function (el) {
                el.checked = true;
            });
        };

        $scope.selectNone = function () {
            angular.forEach($scope.selections, function (el) {
                el.checked = false;
            });
        };

        $scope.removeSelected = function () {
            var counter = _($scope.selections).filter({checked: true}).size();
            ConfirmModal.show({
                title: "არჩევანის წაშლა",
                message: "გსურთ " + counter.toString() + " არჩევანის წაშლა?"
            }).result.then(function () {
                $q.all(_($scope.selections).filter({checked: true}).map(function (selection) {
                    return Selection.removeSelection(selection);
                }).value()).then(function (results) {
                    update();
                    toastr.success('წაშლილია ' + counter + ' ჩანაწერი');
                });
            });
        };

        $scope.editSelected = function () {
            var counter = _($scope.selections).filter({checked: true}).size();

            $uibModal.open({
                controller: "SessionEditSelectedController",
                templateUrl: _pb + 'admin/selection/edit-selected-selection.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            sessions: $scope.sessions
                        };
                    }
                }
            }).result.then(function (params) {
                $q.all(_($scope.selections).filter({checked: true}).map(function (selection) {
                    return Selection.prove({
                        selection: selection._id,
                        seminar: params.seminar,
                        lecture: params.lecture
                    });
                }).value()).then(function (results) {
                    update();
                    toastr.success('რედაქტირებულია ' + counter + ' ჩანაწერი');
                });
            });
        };

        function getSelectedItems (selection) {
            return selection.checked;
        }

        $scope.archiveSelections = function () {
            var counter = _($scope.selections).filter({checked: true}).size();
            var selectedSelections = _.map($scope.selections.filter(getSelectedItems), function (selection) {
                return selection._id
            });

            ConfirmModal.show({
                title: "ჩანაწერის დაარქივება",
                message: "გსურთ " + counter.toString() + " ჩანაწერის დაარქივება?"
            }).result.then(function () {
                Selection.archiveSelections(selectedSelections).then(function () {
                    toastr.success('დაარქივებულია ' + counter + ' ჩანაწერი');
                })
            });
        };
    }
]);
